__turbopack_context__.v({
  "large": "Teaser-module-scss-module__5Rc21G__large",
  "teaser": "Teaser-module-scss-module__5Rc21G__teaser",
  "teaserContainer": "Teaser-module-scss-module__5Rc21G__teaserContainer",
  "teaserContent": "Teaser-module-scss-module__5Rc21G__teaserContent",
  "teaserTextContent": "Teaser-module-scss-module__5Rc21G__teaserTextContent",
  "teaserWrapper": "Teaser-module-scss-module__5Rc21G__teaserWrapper",
});
